export default {

    url:{
        type:String,
        default:''
    }

}
